export const CAMERA_SETTINGS = {
  far: 500, // frustum far plane
  sensitivity: Math.pow(0.95, 3.0),
  defaultZoom: 50,
  minZoom: 3,
  maxZoom: 100,
  panDuration: 0.2,
} as const;

export const DEFAULT_AP_POSITION = { x: -2.5, y: 0 } as const;
export const DEFAULT_CLIENT_POSITION = { x: 2.5, y: 0 } as const;
export const DEVICE_SIZE = 0.4;

export const Z = {
  COVERAGE: -1,
  LINK: -0.5,
  DEFAULT: 0,
  ACTIVE: 1,
  HOVER: 2,
  HOVER_ACTIVE: 2.5,
  DRAGGING: 3,
} as const;
